import { CustomAlarmActivationMode } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/custom-alarm-activation-confirmation-modal/custom-alarm-active-confirmation-modal.model';
import {
    CustomAlarmActionAmount,
    CustomAlarmListItem,
} from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/settings-devices-custom-alarm-list.model';
import {
    CUSTOM_ALARM_ACTIVATION_MODAL_TEXTS,
    CUSTOM_ALARM_ACTIVE_CONFIRMATION_BUTTON_TEXTS,
} from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/custom-alarm-activation-confirmation-modal/custom-alarm-active-confirmation-modal.constants';

export const getTexts = (selectedRows: CustomAlarmListItem[], mode: CustomAlarmActivationMode) => {
    const amount: CustomAlarmActionAmount = selectedRows.length === 1 ? 'single' : 'multiple';

    return CUSTOM_ALARM_ACTIVATION_MODAL_TEXTS[mode][amount];
};

export const getButtonText = (action: CustomAlarmActivationMode) =>
    CUSTOM_ALARM_ACTIVE_CONFIRMATION_BUTTON_TEXTS[action];
